'use client';
import { Button } from '@curology/ui-components-web/react/Button';
import { EditIcon } from '@curology/ui-components-web/react/Icon/icons/EditIcon';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { type Patient } from '@/types/productSelectionAndCheckout/types';
import { AnalyticsEvent, trackEvent } from '@/utils/analytics';

import { CHECKOUT_STATES } from '../consts/checkoutStates';

const CcEntrySummary: React.FC<{
  cardLastFour?: string;
  checkoutState: string;
  patient: Patient;
  setCheckoutState: React.Dispatch<React.SetStateAction<string>>;
}> = ({
  cardLastFour = undefined,
  checkoutState,
  patient,
  setCheckoutState,
}) => {
  if (
    checkoutState !== CHECKOUT_STATES.shippingAddressEntry &&
    checkoutState !== CHECKOUT_STATES.ccAndShippingAddressCompleted
  ) {
    return null;
  }

  return (
    <div className="cur-bg-surface-neutral cur-mt-4 cur-p-4">
      <Button
        buttonType="text"
        className="cur-float-right"
        data-sentry-id="Edit Stripe CC info"
        iconStart={<EditIcon />}
        onClick={() => {
          setCheckoutState(CHECKOUT_STATES.ccEntry);

          trackEvent(AnalyticsEvent.CHECKOUT_CARD_EDIT_BUTTON_CLICKED, {
            card: 'payment',
          });
        }}
        size="sm"
        state="dark"
      />
      <Typography size="subhead">
        {patient.hasCompletedCcEntry || patient.collectedCardLastFour
          ? 'Confirm payment method'
          : 'Payment method'}
      </Typography>
      <Typography className="cur-mt-4 data-hj-suppress" size="meta">
        Card ending in {cardLastFour}
      </Typography>
    </div>
  );
};

export default CcEntrySummary;
